module.exports = __webpack_public_path__ + "static/super-admin-faqs-list-e9686a1530a82bd7cfd7e73c5545f111.png";